import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=9816378a&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=ts&"
export * from "./Score.vue?vue&type=script&lang=ts&"
import style0 from "./Score.vue?vue&type=style&index=0&id=9816378a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9816378a",
  null
  
)

export default component.exports